import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class KnowledgeShareClassifyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'knowledgeshare-classify'
  }

}